var ParameterClass = (function () {
    function ParameterClass() {
    }
    return ParameterClass;
}());
//# sourceMappingURL=ParameterClass.js.map